<template>
    <AllRMAPurchasing></AllRMAPurchasing>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const AllRMAPurchasing = defineAsyncComponent(() =>
    import("../../components/Purchasing/RMATable.vue")
);

export default {
    name: "All_Purchashing",
    components: { AllRMAPurchasing, AuthLayout },
};
</script>
